<template>
  <nav-bar />
  <div class="container">
    <div class="clearfix"></div>
    <router-link
      :to="{ name: 'LocationMenu', params: { locationId: locationId } }"
    >
      <button class="btn btn-info float-start">
        Back To Menu
      </button></router-link
    >
    <div class="clearfix"></div>
    <div class="text-center">
      <h1 class="mb-0">{{ locName }}</h1>
      <p class="text-muted">{{ locAddress }}</p>
    </div>
    <form @click.prevent>
      <div class="row g-3 align-items-center">
        <div class="col-auto d-block mx-auto">
          <h1>Update Item</h1>
        </div>
      </div>
      <div class="row g-3 align-items-center">
        <div class="col-auto d-block mx-auto">
          <div
            class="form-floating mb-3"
            :class="{ 'form-group-error': v$.itemName.$error }"
          >
            <input
              class="w250 form-control"
              id="floatItemName"
              placeholder="Enter Item Name"
              type="text"
              v-model.trim="itemName"
            />
            <label for="floatItemName">Enter Item Name</label>
            <span class="error-feedback" v-if="v$.itemName.$error">{{
              v$.itemName.$errors[0].$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="row g-3 align-items-center">
        <div class="col-auto d-block mx-auto">
          <div
            class="form-floating mb-3"
            :class="{ 'form-group-error': v$.itemPrice.$error }"
          >
            <input
              class="w250 form-control"
              id="floatItemPrice"
              placeholder="Enter Item price"
              type="number"
              v-model.trim="itemPrice"
            />
            <label for="floatItemPrice">Enter Item price</label>
            <span class="error-feedback" v-if="v$.itemPrice.$error">{{
              v$.itemPrice.$errors[0].$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="row g-3 align-items-center">
        <div class="col-auto d-block mx-auto">
          <div
            class="form-floating mb-3"
            :class="{ 'form-group-error': v$.quantity.$error }"
          >
            <input
              class="w250 form-control"
              id="floatItemQty"
              placeholder="Enter Item quantities"
              type="number"
              v-model.trim="quantity"
            />
            <label for="floatItemQty">Enter Item quantities</label>
            <span class="error-feedback" v-if="v$.quantity.$error">{{
              v$.quantity.$errors[0].$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="row g-3 align-items-center">
        <div class="col-auto d-block mx-auto">
          <div
            class="form-floating mb-3"
            :class="{ 'form-group-error': v$.description.$error }"
          >
            <textarea
              id="floatItemDesc"
              class="w250 h200 form-control"
              placeholder="Enter Item Description"
              v-model.trim="description"
            ></textarea>
            <label for="floatItemDesc">Enter Item Description</label>
            <span class="error-feedback" v-if="v$.description.$error">{{
              v$.description.$errors[0].$message
            }}</span>
          </div>
        </div>
      </div>
      <div class="row g-3 align-items-center">
        <div class="col-auto d-block mx-auto">
          <div
            class="form-floating mb-3"
            :class="{ 'form-group-error': v$.pickedCategory.$error }"
          >
            <select
              id="floatingSelect"
              class="w250 form-select"
              v-model.trim="pickedCategory"
            >
              <option
                v-for="(cat, i) in listOfCategories"
                :key="i"
                :value="cat.id"
              >
                {{ cat.name }}
              </option>
            </select>
            <label for="floatingSelect">Select Category Name</label>
            <span class="error-feedback" v-if="v$.pickedCategory.$error">{{
              v$.pickedCategory.$errors[0].$message
            }}</span>
          </div>
        </div>
      </div>
      <br />
      <div class="row g-3 align-items-center">
        <div
          class="col-auto d-block mx-auto alert alert-success"
          v-if="successMessage.length > 0"
        >
          {{ successMessage }}
        </div>
        <div
          class="col-auto d-block mx-auto alert alert-danger"
          v-if="errorMessage.length > 0"
        >
          {{ errorMessage }}
        </div>
      </div>
      <br />
      <div class="row g-3 align-items-center">
        <div class="col-auto d-block mx-auto">
          <button
            type="button"
            @click="UpdateItem()"
            class="w250 btn btn-warning"
          >
            update Now
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import axios from "axios";
import useValidate from "@vuelidate/core";
import { required, minLength, maxLength, between } from "@vuelidate/validators";
export default {
  name: "UpdateItem",
  components: {
    NavBar,
  },
  data() {
    return {
      v$: useValidate(),
      userId: "",
      userName: "",
      locationId: this.$route.params.locationId,
      itemId: this.$route.params.itemId,
      locName: "",
      locAddress: "",
      successMessage: "",
      errorMessage: "",
      itemName: "",
      itemPrice: "",
      quantity: 1,
      description: "",
      pickedCategory: "",
    };
  },
  computed: {
    ...mapState([
      "isUserLoggedIn",
      "loggedInUserId",
      "numOfCategories",
      "listOfCategories",
    ]),
  },
  validations() {
    return {
      itemName: { required, minLength: minLength(6) },
      description: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(120),
      },
      quantity: { required, between: between(1, 100000) },
      itemPrice: { required, between: between(0, 1000000) },

      pickedCategory: { required },
    };
  },
  async mounted() {
    let user = localStorage.getItem("user-info");
    if (!user) {
      this.redirectTo({ val: "SignUp" });
    } else {
      this.userName = JSON.parse(user).name;
      this.userId = JSON.parse(user).id;
      this.isLoggedInUser();
      // this.locationId = this.$route.params.locationID;
      this.displayAllCategories({
        userIdIs: this.userId,
        locationIdIs: this.locationId,
      });
      this.canUserAccessThisLocation({
        userIdIs: this.userId,
        locationIdIs: this.locationId,
        redirectToPage: "home",
      });
      this.canUserAccessThisItem({
        userIdIs: this.userId,
        locationIdIs: this.locationId,
        itemIdIs: this.itemId,
        redirectToPage: "home",
      });
    }
    this.getLocationInfo(this.userId, this.locationId);
    this.getItemInfo(this.userId, this.locationId, this.itemId);
  },
  methods: {
    ...mapMutations([
      "isLoggedInUser",
      "displayAllCategories",
      "canUserAccessThisLocation",
      "canUserAccessThisItem",
    ]),
    ...mapActions(["redirectTo"]),
    async getItemInfo(userId, locationId, itemId) {
      let result = await axios.get(
        `https://my-json-server.typicode.com/y-alhouri/data/items?userId=${userId}&locId=${locationId}&id=${itemId}`
      );
      let resultData = result.data[0];
      if (result.status == 200) {
        this.description = resultData.description;
        this.itemName = resultData.name;
        this.quantity = resultData.qty;
        this.itemPrice = resultData.price;
        this.pickedCategory = resultData.catId;
      }
    },
    async getLocationInfo(userId, locId) {
      let result = await axios.get(
        `https://my-json-server.typicode.com/y-alhouri/data/locations?userId=${userId}&id=${locId}`
      );
      let locDetails = [];
      if (result.status == 200) {
        locDetails = result.data;
        if (result.data.length > 0) {
          this.locName = locDetails[0].name;
          this.locAddress = locDetails[0].address;
        }
      }
    },
    async UpdateItem() {
      this.v$.$validate();
      if (!this.v$.$error) {
        console.log("Validated");
        let results = await axios.put(
          `https://my-json-server.typicode.com/y-alhouri/data/items/${this.itemId}`,
          {
            name: this.itemName,
            price: parseFloat(this.itemPrice.toFixed(2)),
            description: this.description,
            qty: parseInt(this.quantity),
            userId: this.userId,
            locId: parseInt(this.locationId),
            catId: this.pickedCategory,
          }
        );
        if (results.status == 200) {
          this.successMessage = " Item  Updated ..  ";
          this.errorMessage = "";
          setTimeout(() => {
            this.$router.push({
              name: "LocationMenu",
              params: { locationId: this.locationId },
            });
          }, 1000);
        } else {
          //show error message
          this.successMessage = "";
          this.errorMessage = `somthing went wrong, try again!`;
        }
      } else {
        this.successMessage = "";
        this.errorMessage = "You must fill in all required fields!";
      }
    },
  },
};
</script>

<style lang="css" scoped>
.w250 {
  min-width: 250px;
}
.h200 {
  min-height: 200px;
}
.form-group-error {
  color: red;
}
.form-group-error input,
.form-group-error textarea,
.form-group-error select {
  border-color: red;
}
</style>
